import React, { Component, Fragment } from 'react';
import SelectUSState from '../../../utility_components/us-states-selector-fork/src/SelectUSState';
import PersistenceManager from "../../../functions/persistence";

export default class AddressUpdatePanel extends Component {
    constructor(props) {
        super(props);
        this.updateAddress = this.updateAddress.bind(this);
        this.state = {loading: false}
    }


    updateAddress() {
        //Post updated address
        if(this.state.loading) return;
        let addressId = PersistenceManager.retrieveAddressID() ? PersistenceManager.retrieveAddressID() : this.props.tmpAddress.id;
        let url = `${window.relativeURI()}/user/addresses/${addressId}/update/api`;
        let payload = {
            address: this.props.address,
            address2: this.props.address2,
            city: this.props.city,
            state: this.props.state,
            zip: this.props.zip,
            display_name: this.props.displayName,
            delivery_instructions: this.props.deliveryInstructions,
            user_id: session.uid ? session.uid : PersistenceManager.retrieveUserId()
        };
        let headers = new Headers({
            'X-CSRF-TOKEN': window.session.token,
            'credentials': 'same-origin',
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest"});
        this.setState({loading: true}, () => {
            fetch(url, {
                method: 'PUT',
                headers: headers,
                body: JSON.stringify(payload)
            }).then( (fetchResponse) => {
                if(fetchResponse.status > 300 && fetchResponse.status < 400) document.location.reload() //Follow redirects
                if(fetchResponse.ok) {
                    fetchResponse.json().then( (resJson) => {
                        this.setState({loading: false}, () => {
                            this.props.setAddressID(resJson.id);
                            this.props.proceedFunction(resJson);
                        });
                    }, (jsonParseFailure) => {
                        console.log(jsonParseFailure);
                    })
                }else {
                    if(fetchResponse.status === 422) {
                        fetchResponse.json().then( (validationJson) => {
                            console.log('validation error');
                            console.log(validationJson);
                            this.setState({loading: false});
                        }, (failureRejection) => {
                            console.log(failureRejection);
                        });
                    }
                    console.log('response not ok');
                }

            }, (fetchFailure) => {
                this.setState({loading: false});
                console.log('fetch failed');
                console.log(fetchFailure);
            });
        });
    }

    render() {
        return (

            <div className="container">
                <h4>Update Address for {this.props.serviceType.name}</h4>

                <div className='row'>
                    <div className={'col-lg-6'}>
                        <div className='form-group'>
                            <label htmlFor="address">Address</label>
                            <input type='text' className='form-control' value={this.props.address} onChange={this.props.handleChangeToAddress}/>
                        </div>
                    </div>
                    <div className={'col-lg-6'}>
                        <div className='form-group'>
                            <label htmlFor="address2">Address 2 (optional)</label>
                            <input type='text' className='form-control' value={this.props.address2} onChange={this.props.handleChangeToAddress2}/>
                        </div>
                    </div>
                </div>

                <div className={'row'}>
                    <div className={'col-lg-4'}>
                        <div className='form-group'>
                            <label htmlFor="address">City</label>
                            <input type='text' className='form-control' value={this.props.city} onChange={this.props.handleChangeToCity}/>
                        </div>
                    </div>
                    <div className={'col-lg-4'}>
                        <div className='form-group'>
                            <label htmlFor="address2">State</label>
                            <SelectUSState id="updateAddressSelectState" className="form-control" onChange={this.props.handleChangeToState} value={this.props.state}/>
                        </div>
                    </div>
                    <div className={'col-lg-4'}>
                        <div className='form-group'>
                            <label htmlFor="address2">Zip</label>
                            <input className='form-control' onChange={this.props.handleChangeToZip} type="text" value={this.props.zip}/>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className={'col-lg-6'}>
                        <div className='form-group'>
                            <label htmlFor="address">Delivery Instructions (optional)</label>
                            <input className='form-control' onChange={this.props.handleChangeToDeliveryInstructions} type="text" value={this.props.deliveryInstructions}/>
                        </div>
                    </div>
                    <div className={'col-lg-6'}>
                        <div className='form-group'>
                            <label htmlFor="address2">Display Name (optional)</label>
                            <input className='form-control' onChange={this.props.handleChangeToDisplayName} type="text" value={this.props.displayName}/>
                        </div>
                    </div>
                </div>

                <div className="row pb-5">
                    {this.props.backFunction ? (
                    <div className="col pb-5 text-center mt-1 mb-3">
                        <button onClick={this.props.backFunction} className="btn btn-secondary">{this.props.backText}</button>
                    </div>) : ''}

                    <div className="col pb-5 text-center mt-1 mb-3">
                        {this.props.backFunction ? <button onClick={this.updateAddress} className={`btn btn-primary`}>{this.props.proceedText}</button> : (
                            <button onClick={this.updateAddress} className={`btn btn-primary`}>{this.props.proceedText}</button>
                        )}
                    </div>
                </div>

            </div>


        );
    }
}